const Form106TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "填寫意願書",
        confirmation: "確認",
    },

    importantNotesContent: {
        title: "填寫須知",
        p1First: "如你的子女",
        p1FileCheck: "不是兒童體能智力測驗中心／測研中心的個案",
        p1Second: "，或你已決定",
        p1ProSubject: "按照專業人士的評估及建議為子女申請於下學年入讀特殊學校",
        p1Third: "，便",
        p1NotNeed: "毋須",
        p1End: "填寫及交回此家長意願書。",
        p2: "此網上表格<b><u>必須以「智方便+」進行數碼簽署以遞交</u></b>。",
        p3: "請先參閱以下的注意事項，以了解意願書的用途和相關安排。",
        termsConditions: "我已閱讀、理解並同意上述注意事項、條款和條件。",
    },

    GuidanceNotesContent: {
        title: "注意事項",
        p2: "你的適齡子女將於下學年升讀小一。為使有關學校了解你子女的需要，從而為他們盡早提供合適的支援，教育局現徵求你的同意，以便向你子女所屬的兒童體能智力測驗中心／測研中心索取他／她的評估資料。如你同意，教育局會把意願書送交有關測驗中心／測研中心，以便測驗中心／測研中心安排一式兩份的評估資料送交本局。教育局會於小一「統一派位」結果公布後，盡早把其中一份資料轉交你子女將入讀的官立、資助或直接資助計劃小學，並保留另一份資料備考。教育局所保留的一份資料會在完成上述資料傳遞工作後被銷毀。如有需要，我們會以電話與你聯絡，確認你子女將入讀的小學。",
        p3: "小學如在你的子女入學前取得他們的評估資料，可及早規劃，並為他們提供合適的支援。你的子女入學後，如有更新資料（包括跟進評估和其他相關訓練及專科跟進等），家長可把相關資料直接交給學校作參考和合適的跟進。",
        termsConditions: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
    },

    applicationInformationContent: {
        label: {
            title1: "1.  兒童資料：",
            childNameZh: "中文姓名",
            noChineseName: "沒有中文姓名",
            childNameEn: "英文姓名",
            childGender: "性別",
            childGenderOption: {
                male: "男",
                female: "女",
            },
            childBirthDate: "出生日期",
            childHkidOrOtherIdentityDocumentNumber: "身份證明文件類別",
            childHkidOrOtherIdentityDocumentNumberOption: {
                hkid: "香港身份證",
                otherIdNo: "其他身份證明文件",
            },
            childHkidOrOtherIdentityDocumentNumberText: "號碼",
            hkid: "香港身份證號碼",
            otherIdNo: "其他身份證明文件號碼",
            childIdNumber: "身份證明文件號碼",
            intendedPrimarySchoolName:
                "若你已為子女註冊下學年將入讀的官立、津貼或直接資助計劃小學，請提供下列資料；若現時未能提供可以略過此項。如有需要，我們稍後會以電話與你聯絡，確認你子女將入讀的小學：",
            title2: "2.  家長/監護人意願：",
            childEnrollNextYear1: "我的子女",
            childEnrollNextYear2:
                "於下學年升讀小一，並<u>是</u>以下兒童體能智力測驗中心／測研中心的個案：",
            willNotOption: {
                yes: "會",
                no: "不會",
            },
            agreeNotOption: {
                yes: "同意",
                no: "不同意",
            },
            district: "地區",
            school: "學校",
            trcArchiveNumber: "測驗中心／測研中心的檔案編號",
            nextStepAgreeEnrollNextYear1: "我",
            nextStepAgreeEnrollNextYear2:
                "上述測驗中心／測研中心把我子女的評估資料（如有）送交教育局，並由教育局轉交至我子女將入讀的官立、資助或直接資助計劃小學。",
            nextStepNotAgreeEnrollNextYear1: "我的子女",
            nextStepNotAgreeEnrollNextYear2: "不會",
            nextStepNotAgreeEnrollNextYear3: "於下學年升讀小一。我",
            nextStepNotAgreeEnrollNextYear4:
                "教育局適時聯絡我，跟進評估資料傳遞至小學的安排。",
            title3: "3.  家長/監護人資料：",
            guardianFullNameOption: {
                parent: "家長",
                legalGuardian: "監護人",
            },
            guardianFullNameOptionName: "姓名",
            guardianFullName: "家長／監護人姓名",
            guardianIdentityDocumentNumber: "身份證明文件號碼",
            relationshipToChild: "與兒童關係",
            contactNumber: "聯絡電話",
            address: "地址",
            guardianSign: "家長／監護人簽署",
            guardianSignDate: "簽署日期",
            statementCheck: {
                label: "本人謹作以下聲明",
                label1: "本人為上述兒童的家長；及",
                label2: "本人為上述兒童的監護人；及",
                label3: "此表格內的資料全屬正確無訛。倘若資料有誤，本人明白教育局可能無法辦理或繼續處理有關表格。",
            },
        },

        errorMsg: {
            childNameZh: "中文姓名",
            childNameEn: "英文姓名",
            childGender: "性別",
            childBirthDate: "出生日期",
            childHkidOrOtherIdentityDocumentNumber: "身份證明文件類別",
            childIdNumber: "身份證明文件號碼",
            guardianFullName: "家長／合法監護人姓名",
            relationshipToChild: "與兒童關係",
            contactNumber: "聯絡電話：",
            address: "地址：",
            guardianSign: "家長／合法監護人簽署：",
            guardianSignDate: "簽署日期：",
            numericOnly: "僅限數字",
            cannotContainNumbers: "不能輸入數字",
        },
    },

    submittedDialog: {
        note1: "你已成功送出表格。",
        note2: "請將專業發展資料冊（附「行動研究計劃」）一式兩份",
        note3: "連同此申請表",
        note4: "，經由以下方法遞交:",
        // note5: "學校發展資料冊一式兩份",
        note6: "",
        note7: "以專人遞交至香港添馬添美道2號政府總部東翼5樓教育局專業發展及培訓分部〈請在遞交日期最少2個工作天前致電3509 7471登記預約〉；或",
        note8: "以掛號郵件寄交至",
        note9: "香港添馬添美道2號",
        note10: "政府總部東翼5樓",
        note11: "教育局",
        note12: "專業發展及培訓分部",
        note13: "學校領導及專業發展組收",
    },
    parameter: {
        centerSC: "中心名稱（簡體中文）",
        centerTC: "中心名稱（繁體中文）",
        centerEN: "中心名稱（英文）",
    },
};

export default Form106TC;
